<template>
  <div class="hello">
    <remindListTop @event3="change3($event)" @transformVal="getVal" @fatherMethod="getremindlist" @exportMethod="exportHandle" :exportStatus="exportLoading"></remindListTop>
    <!-- <contract v-if="isHandled==0"></contract>
      <contractProcessed v-if="isHandled==1"></contractProcessed> -->
    <div class="contract">
      <div class="main-con">
        <div class="crumbs">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>通知</el-breadcrumb-item>
            <el-breadcrumb-item>待办事项</el-breadcrumb-item>
            <el-breadcrumb-item>合同到期提醒</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span v-show="isHandled =='0'">待处理</span>
              <span v-show="isHandled =='1'">已处理</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="idCardTable">
          <el-table :data="tableData" :max-height="tableHeight-180" style="width: 99%" stripe v-loading="listLoading">
            <!-- <el-table-column align="center" type="selection" width="50px"></el-table-column> -->
            <el-table-column align="center" label="序号" prop="num" width="50px"></el-table-column>
            <el-table-column align="center" label="项目名称" prop="StrObjName" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="档案号" prop="StrFileNo" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="姓名" prop="StrEmpName" min-width="70px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="身份证号码" prop="StrIdCard" min-width="160px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="合同（协议）类型" prop="StrContractType" min-width="140px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="劳动合同起始时间" min-width="140px" fit :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{isNull(scope.row.DtContractBtime)?'': scope.row.DtContractBtime}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="劳动合同到期时间" min-width="140px" fit :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{isNull(scope.row.DtContractTime)?'': scope.row.DtContractTime}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="合同到期提醒" min-width="100px" fit :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span style="color: #F78500;">{{isNull(scope.row.DtContractTime)?'未填到期时间':diffDate(scope.row.DtContractTime)}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="客服" prop="StrUserName" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" fixed="right" label="操作" min-width="260px">
              <template slot-scope="scope">
                <el-button type="success" size="small" plain v-if="isHandled =='0'" @click="updateContract(scope.row)">更新合同</el-button>
                <el-button type="warning" size="small" plain v-if="isHandled =='0'" @click="addHandle(scope.row)">确认处理</el-button>
                <el-button type="danger" size="small" plain v-if="isHandled =='0'&& scope.row.StrWorkState=='在职'" @click="quit(scope.row)">离职</el-button>
                <el-button type="warning" size="small" plain v-if="isHandled =='1'" @click="revokeHandle(scope.row)">撤销处理</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" v-show="totalcount>0">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage3" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total,sizes,prev,pager, next, jumper" :total="this.totalcount"></el-pagination>
          </div>
        </div>
      </div>
      <el-dialog title="确认处理" :visible.sync="dialogVisible1" width="410px">
        <span>若您已在线下完成处理，无需再进行其他线上操作，请点击确认</span>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible1 = false">取消</button>
          <button class="search" @click="changeSolve" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <el-dialog title="更改合同" :visible.sync="dialogVisible2" width="480px">
        <span>合同（协议）类型</span>
        <div class="contractType" style="margin-top: 5px;">
          <el-select v-model="typeContract" size="small" placeholder="请选择" filterable>
            <el-option v-for="item in agreementList" :key="item.value" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
        </div>
        <div class="updateContract">
          <div class="upLeft">
            <div>劳动合同起始时间</div>
            <div class="dataSele">
              <el-date-picker v-model="startTime" type="date" placeholder="选择日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </div>
          <div class="upLeft">
            <div>劳动合同到期时间</div>
            <div class="dataSele">
              <el-date-picker v-model="endTime" type="date" placeholder="选择日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible2 = false">取消</button>
          <button class="search" @click="submitUpdate" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <el-dialog title="离职" :visible.sync="dialogVisible3" width="410px">
        <span>您正在给"{{this.emprow.StrEmpName}}""{{this.emprow.StrIdCard}}"办理离职手续，请可核对无误后再确认</span>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible3 = false">取消</button>
          <button class="search" @click="confirmQuit()" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <el-dialog title="撤销处理" :visible.sync="dialogVisible4" width="30%">
        <span>点击“撤销处理”后，本条待办事项将重新在“待办事项”列表中</span>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible4 = false">取消</button>
          <button class="search" @click="revokeSubmit" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "./../../common";
  import {
    parseTime
  } from './../../utils' //格式化时间格式
  import remindListTop from "./components/remindListTop";
  // import contract from "./contract";
  // import contractProcessed from "./contractProcessed";
  export default {
    components: {
      parseTime,
      remindListTop,
    },
    data() {
      return {
        tableHeight: 0,
        pickerOptions: {
          // disabledDate(time) {
          //   return time.getTime() > Date.now();
          // },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }]
        },
        listLoading: false,
        isHandled: 0,
        emprow: "",
        totalcount: null,
        currpage: 1,
        status: 0,
        select: "",
        value1: "",
        //协议下拉列表
        agreementList: [{
            label: '劳动合同',
            value: 1
          },
          {
            label: '退休返聘协议',
            value: 2
          },
          {
            label: '实习协议',
            value: 3
          },
          {
            label: '兼职协议',
            value: 4
          },
          {
            label: '自由职业者服务协议',
            value: 5
          },
          {
            label: '劳务协议',
            value: 6
          },
          {
            label: '非全日制用工协议',
            value: 7
          }
        ],
        //合同类型
        editContractQuery01: {
          tableid: "XZ_emp_UserBase",
          excelpath: '',
          execlline: '',
          cluname: 'StrContractType',
          cluvalue: ''
        },
        //合同起始时间
        editContractQuery02: {
          tableid: "XZ_emp_UserBase",
          excelpath: '',
          execlline: '',
          cluname: 'DtContractBtime',
          cluvalue: ''
        },
        //合同到期时间
        editContractQuery03: {
          tableid: "XZ_emp_UserBase",
          excelpath: '',
          execlline: '',
          cluname: 'DtContractTime',
          cluvalue: ''
        },
        //对应种类
        clunameType: '',
        //合同起始时间
        startTime: '',
        //合同到期时间
        endTime: '',
        //合同类型
        typeContract: '',
        //是否更新成功
        isSuccess: false,
        dialogVisible1: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        currentPage3: 1,
        tableData: [],
        remindQuery: {
          tableid: "XZ_emp_UserBase",
          pagecount: 10,
          currpage: 1,
          content: 'cont',
          strstatus: "0",
          strempname: ""
        },
        exportQuery: {
          tableid: "XZ_emp_UserBase",
          pagecount: 100000,
          currpage: 1,
          content: 'cont',
          strstatus: "0",
          strempname: ""
        },
        pagecount: 10,
        pageSize: 10,
        //确认处理参数-档案号
        strfileno: '',
        //导出按钮加载状态
        exportLoading: false,
        info: {},
      }
    },
    mounted() {
      this.calHeight();
      this.getremindlist();
    },
    methods: {
      //一键导出
      exportHandle() {
        this.exportLoading = true
        xz.outputQueryEmpCust(this.exportQuery).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/xlsx`
            })
            let aLink = document.createElement("a")
            aLink.download = '导出列表.xlsx'; //这里写保存时的文件名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.expLoading = false;
          } else {
            this.$message({
              message: "导出错误，请稍后再试",
              type: "error"
            });
          }
          this.exportLoading = false
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      jugdeDate(date) {
        if (date <= 30) {
          return date + '天'
        } else if (date > 30 && date < 360) {
          let d = date % 30;
          let m = Math.floor(date / 30);
          console.log('y', d, m);
          if (d == 0) {
            return m + '个月'
          } else {
            return m + '个月' + d + '天'
          }
        } else if (date > 360 && date < 1080) {
          return '1年以上'
        } else {
          return '1年以上'
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
      },
      change3(data) {
        this.isHandled = data;
        this.remindQuery.strstatus = data
        this.remindQuery.currpage = 1
      },
      getVal(data) {
        // console.log('名称',data)
        this.remindQuery.strempname = data
      },
      handleCurrentChange(val) {
        this.currpage = `${val}`;
        this.remindQuery.currpage = `${val}`;
        this.getremindlist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.remindQuery.pagecount = `${val}`;
        this.pageSize = parseInt(val);
        this.getremindlist();
      },
      //处理
      addHandle(row) {
        this.info = row;
        this.dialogVisible1 = true;
        this.strfileno = row.StrFileNo
      },
      //确认处理
      changeSolve() {
        let d = {
          status: 1, //1 处理，0 退回
          content: 'cont',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "处理成功！",
              type: "success"
            });
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible1 = false;
        });
      },
      //确认撤销
      revokeHandle(row) {
        this.info = row;
        this.dialogVisible4 = true;
        this.strfileno = row.StrFileNo;
      },
      //确认撤销处理
      revokeSubmit() {
        let d = {
          status: 0, //1 处理，0 退回
          content: 'cont',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "撤销成功！",
              type: "success"
            });
            this.dialogVisible4 = false;
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible4 = false;
        });
      },
      //更改合同
      updateContract(row) {
        this.emprow = row;
        this.dialogVisible2 = true;
        if (this.isNull(row.DtContractBtime)) {
          this.startTime = parseTime(new Date(), '{y}-{m}-{d}')
        } else {
          //合同起始时间
          this.startTime = row.DtContractBtime.split('/').join('-')
        }
        if (this.isNull(row.DtContractTime)) {
          this.endTime = parseTime(new Date(), '{y}-{m}-{d}')
        } else {
          //合同到期时间 
          this.endTime = row.DtContractTime.split('/').join('-')
        }
        //合同类型
        this.typeContract = row.StrContractType
        this.editContractQuery01.excelpath = row.StrExcelPath
        this.editContractQuery01.execlline = row.IntExcelLine
        this.editContractQuery02.excelpath = row.StrExcelPath
        this.editContractQuery02.execlline = row.IntExcelLine
        this.editContractQuery03.excelpath = row.StrExcelPath
        this.editContractQuery03.execlline = row.IntExcelLine
      },
      //确认更改合同
      submitUpdate() {
        //合同类型
        if (this.isNull(this.typeContract)) {
          this.$message({
            type: 'warning',
            message: '请选择合同类型'
          })
          return false
        }
        //合同起始时间
        if (this.isNull(this.startTime)) {
          this.$message({
            type: 'warning',
            message: '请选择合同起始时间'
          })
          return false
        }
        //合同到期时间 
        if (this.isNull(this.endTime)) {
          this.$message({
            type: 'warning',
            message: '请选择合同到期时间'
          })
          return false
        }
        // if (this.isSuccess == true) {
        //   this.$message({ type: 'success', message: '更改成功' })
        // }
        this.editContractQuery01.cluvalue = this.typeContract;
        this.editContractQuery02.cluvalue = this.startTime.split('-').join('-');
        this.editContractQuery03.cluvalue = this.endTime.split('-').join('-')
        this.editInfoSubmit(this.editContractQuery01, this.editContractQuery02, this.editContractQuery03)
      },
      //更改合同
      async editInfoSubmit(query1, query2, query3) {
        let d = {
          type: 2,
          StrExcelPath: this.emprow.StrExcelPath,
          IntExcelLine: this.emprow.IntExcelLine,
          StrContractType: this.typeContract,
          DtContractBtime: this.startTime,
          DtContractTime: this.endTime
        }
        xz.WaiterWorkerOption(d).then(res => {
          if (res.status == 'ok') {
            this.$message.success('修改成功！')
            this.getremindlist();
          } else {
            this.getremindlist();
            this.$message.error(res.msg);
          }

          this.dialogVisible2 = false;
        });
      },
      //离职
      quit(row) {
        this.emprow = row;
        this.dialogVisible3 = true;
      },
      //确认离职
      confirmQuit() {
        let d = {
          type: 3,
          StrWorkState: '离职',
          StrExcelPath: this.emprow.StrExcelPath,
          IntExcelLine: this.emprow.IntExcelLine,
        }
        xz.WaiterWorkerOption(d).then(res => {
          if (res.status == 'ok') {
            this.$message.success('修改成功！')
            this.getremindlist();
          } else {
            this.getremindlist();
            this.$message.error(res.msg);
          }
          this.dialogVisible3 = false;
          this.emprow = "";
          this.value1 = "";
        });
      },
      //获取待办事项列表
      getremindlist() {
        // this.tableData = []
        this.listLoading = true
        xz.getremindlist(this.remindQuery, localStorage.loginRoletype).then(res => {
          if (res.data && res.data.length > 0) {
            let i = 1 + (this.currpage - 1) * 10;
            res.data.forEach(l => {
              l.DtContractBtime ? (l.DtContractBtime = l.DtContractBtime.substring(0, 10)) : '-';
              l.DtContractTime ? (l.DtContractTime = l.DtContractTime.substring(0, 10)) : '-';
              // this.calculateDays(l.DtContractTime)
              // var dueDate = this.calculateDays(l.DtContractTime)
              // console.log('dueDate',dueDate)
              // l['dueDate'] = dueDate;
              l['num'] = i++;
            });
            this.tableData = res.data;
            this.totalcount = parseInt(res.count);
          } else {
            this.tableData = []
            this.totalcount = 0
          }
          this.listLoading = false
        })
      },
      //计算相差天数
      calculateDays(sDate2) {
        var aDate, oDate1, oDate2, iDays;
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var sDate1 = year + "-" + month + "-" + day;
        aDate = sDate1.split("-");
        oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]); //转换为yyyy-MM-dd格式
        aDate = sDate2.split("-");
        oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]);
        var iDays = (oDate2 - oDate1) / 1000 / 60 / 60 / 24; //把相差的毫秒数转换为天数
        if (iDays > 0) {
          iDays = Math.ceil(iDays);
          return (iDays)
        } else {
          iDays = Math.floor(iDays);
          return (iDays)
        }
      },
      //计算两个日期相差年月日
      diffDate(date1) {
        let begin = new Date(date1)
        let end = new Date();
        // 如果开始时间晚于结束时间，交换日期，并记录交换状态
        let swap = false;
        if (begin > end) {
          let tmp = begin;
          begin = end;
          end = tmp;
          swap = true;
        }
        // 分别取二个日期的年、月、日值
        let d1 = begin.getDate();
        let m1 = begin.getMonth() + 1;
        let y1 = begin.getFullYear();
        let d2 = end.getDate();
        let m2 = end.getMonth() + 1;
        let y2 = end.getFullYear();
        // 获取每个月的天数，这里要注意一下闰年的2月
        var getMonthDays = function (y, m) {
          var aMonthDays = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
          if (m == 2 && ((y % 400 == 0) || (y % 4 == 0 && y % 100 != 0))) {
            return 29;
          }
          return aMonthDays[m];
        };

        let y, m, d
        let tempD = 0
        let tmpM = 0
        let tmpY = 0

        // 计算日，不足时向月份借
        if (d2 >= d1) {
          d = d2 - d1
        } else {
          tmpM = -1
          d = getMonthDays(y1, m1) + d2 - d1
        }

        // 计算月，不足时向年份借
        if (m2 + tmpM >= m1) {
          m = m2 + tmpM - m1
        } else {
          tmpY = -1
          m = 12 + m2 + tmpM - m1
        }

        // 计算年
        y = y2 + tmpY - y1

        // 拼接距离字符串 输出格式如："5天"， "5月 05天"， "5年 05月 05日"
        let str = "";
        if (y > 0) {
          str = y + '年' + ("0" + m).substr(-2) + "个月" + ("0" + d).substr(-2) + '天'
        } else if (m > 0) {
          str = m + "个月" + ("0" + d).substr(-2) + '天'
        } else if (d > 0) {
          str = d + '天'
        }
        return (swap ? "剩余" : "已过期") + str
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>